var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5534 10.7068L2.3542 0.200026C1.89189 -0.0666754 1.32369 -0.0666754 0.861882 0.200026C0.40007 0.466224 0.115723 0.95879 0.115723 1.49219V22.5077C0.115723 23.0411 0.40007 23.5336 0.861882 23.7998C1.09279 23.935 1.35042 24 1.60804 24C1.86567 24 2.1233 23.9329 2.3542 23.7998L20.5534 13.2931C21.0163 13.0264 21.2991 12.5338 21.2991 12.0004C21.2991 11.467 21.0153 10.974 20.5534 10.7068Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPlay);
export default __webpack_public_path__ + "static/media/playerPlay.f24a5696062d47c80b955cfea6dc3671.svg";
export { ForwardRef as ReactComponent };